// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"J1-z"};